import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { SubOptionType, FilterCommonValues } from './types';

export const getValue = <T>(values: FilterCommonValues<T>[], subOptionType: SubOptionType): FilterCommonValues<T> => {
  return values && values.find(f => f.subOptionType === subOptionType && isDefinedIncludingZero(f.value))
    || { value: undefined, optionType: undefined };
};
